import { LocalStorageHelper } from "../../helpers";

export const boostedJackpotDateHelper = (boostedJackpotEndTime: string): { days: string, hours: string, minutes: string, seconds: string } => {
const { removeItem } = LocalStorageHelper;
  const currentDate: Date = new Date();
  const target: Date = new Date(`${boostedJackpotEndTime}`);

  const timeDiff: number = target.getTime() - currentDate.getTime();

  if (timeDiff <= 0) {
    // frameSettingsStore.setHasBoostedJackpot(false);
    removeItem('isBoostedJackpotInitialPopup')
    return { days: '00', hours: '00', minutes: '00', seconds: '00' };
  }

  const days: string = Math.floor(timeDiff / (1000 * 60 * 60 * 24))
    .toString()
    .padStart(2, '0');
  const hours: string = Math.floor((timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
    .toString()
    .padStart(2, '0');
  const minutes: string = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60))
    .toString()
    .padStart(2, '0');
  const seconds: string = Math.floor((timeDiff % (1000 * 60)) / 1000)
    .toString()
    .padStart(2, '0');

  return { days, hours, minutes, seconds, };
};
